import dynamic from 'next/dynamic';
import { useAtomValue } from 'jotai';

import { jobActiveStatusAtom } from './job-position.atoms';

const WorkerEntryPointButton = dynamic(
  () => import('../worker-entry-point').then((mod) => mod.WorkerEntryPointButton),
  {
    ssr: false,
  }
);

// Renders the apply CTA for active JPs only. When the JP is offline we
// drop the button entirely — at every render site (sticky panel, skills,
// why-trust-us, job-info, job-application-steps). The recovery path for
// offline JPs lives inside `OfflineJobLandingModal` (auto-opens) and the
// inline `ReopenTriggerButton` rendered as `jobInterestEl` of the sticky
// JobDetailBlock — so a disabled "Candidati ora" sprinkled across the
// page would be redundant noise.
export const JobApplicationEntryPoint = ({ testId }: { testId?: string }) => {
  const jobActiveStatus = useAtomValue(jobActiveStatusAtom);
  if (!jobActiveStatus) return null;
  return <WorkerEntryPointButton fullwidth testId={testId} />;
};
